/** Pagination URLs identify actual pages, never silently coerce garbage to page 1. */
export function listingPage(raw) {
  if (raw === undefined || raw === null) return { page: 1, valid: true };
  if (typeof raw !== 'string' || !/^[1-9]\d*$/.test(raw))
    return { page: 1, valid: false };
  const page = Number(raw);
  return { page, valid: Number.isSafeInteger(page) };
}

export function listingSeoState({
  valid = true,
  loading = false,
  error = false,
  page = 1,
  count = 0,
  totalPages,
  currentPage
}) {
  if (!valid) return { status: 404, indexable: false };
  if (loading) return { status: 200, indexable: false };
  if (error) return { status: 503, indexable: false };
  const last = Number(totalPages);
  if (
    !Number.isSafeInteger(last) ||
    last < 0 ||
    (last === 0 && count > 0) ||
    (currentPage != null && Number(currentPage) !== page)
  )
    return { status: 503, indexable: false };
  if (page > Math.max(1, last) || (page > 1 && count === 0))
    return { status: 404, indexable: false };
  return { status: 200, indexable: count > 0 };
}

export function filterListingHead(
  tags,
  { status, indexable },
  page,
  category = 0
) {
  // Language-specific totals/order differ. Without verified equivalents, do not
  // invent translated page N URLs or cross-language category result clusters.
  return tags.filter((tag) => {
    if (tag.tag === 'link' && tag.props?.rel === 'canonical')
      return status === 200;
    if (tag.tag === 'link' && tag.props?.hreflang)
      return indexable && page === 1 && category === 0;
    if (tag.tag === 'meta' && tag.props?.property === 'og:locale:alternate')
      return indexable && page === 1 && category === 0;
    return true;
  });
}
